module.exports = __webpack_public_path__ + "media/images/programs/header-fed4f32063f6749ad56100fe65f04d17.png";